/**
 * Browser entry point: marks the document as JS-enabled (styles key off
 * .js-loaded) and mounts the app inside the router.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";

if (typeof document !== "undefined") {
	document.documentElement.classList.add("js-loaded");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>,
);
